import PropTypes from "prop-types";
import { Box } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function PageHeader({ title, subtitle, actions, icon }) {
  return (
    <MDBox
      px={{ xs: 2, md: 3 }}
      py={2}
      display="flex"
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", sm: "center" }}
      flexDirection={{ xs: "column", sm: "row" }}
      gap={1.5}
      sx={{ borderBottom: "1px solid", borderColor: "divider" }}
    >
      <Box display="flex" alignItems="center" gap={1.25}>
        {icon}
        <Box>
          <MDTypography variant="h5" fontWeight="medium">
            {title}
          </MDTypography>
          {subtitle && (
            <MDTypography variant="body2" color="text" mt={0.25}>
              {subtitle}
            </MDTypography>
          )}
        </Box>
      </Box>
      {actions && (
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
          {actions}
        </Box>
      )}
    </MDBox>
  );
}

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  icon: PropTypes.node,
};

PageHeader.defaultProps = {
  subtitle: null,
  actions: null,
  icon: null,
};

export default PageHeader;
